/* ============================================================
   RK Blog CRO JS v2 — Progress Bar + Read Time + Mid CTAs
   ============================================================ */
(function() {
  'use strict';

  /* ---- Reading Progress Bar ---- */
  function initProgressBar() {
    var bar = document.querySelector('.rk-progress-bar');
    var label = document.querySelector('.rk-progress-label');
    if (!bar) return;

    var content = document.querySelector('.post-content, .rte, .article__content, .blog-post-detail');
    var totalMinutes = 8;
    if (content) {
      var words = (content.innerText || '').trim().split(/\s+/).length;
      totalMinutes = Math.max(1, Math.round(words / 200));
    }

    function update() {
      var scrollTop = window.scrollY || document.documentElement.scrollTop;
      var docHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (docHeight <= 0) return;
      var pct = Math.min(100, (scrollTop / docHeight) * 100);
      bar.style.width = pct + '%';
      if (label) {
        var remaining = Math.max(0, Math.round(totalMinutes * (1 - pct / 100)));
        if (pct > 5 && pct < 98) {
          label.textContent = remaining <= 0 ? 'Almost done' : remaining + ' min remaining';
          label.classList.add('visible');
        } else {
          label.classList.remove('visible');
        }
      }
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* ---- Inject Read Time into article author block ---- */
  function initReadTime() {
    var el = document.getElementById('rk-read-time');
    if (!el) return;
    var content = document.querySelector('.post-content, .rte, .blog-post-detail');
    if (!content) return;
    var words = (content.innerText || '').trim().split(/\s+/).length;
    var mins = Math.max(1, Math.round(words / 200));
    el.textContent = '⏱ ' + mins + ' min read';
  }

  /* ---- Mid-Article CTA Injection ---- */
  function initMidCTAs() {
    var content = document.querySelector('.post-content.rte, .post-content.page-content-width');
    if (!content) return;

    // Don't double-inject
    if (content.querySelector('.rk-mid-cta')) return;

    var headings = content.querySelectorAll('h2, h3');
    if (headings.length < 3) return;

    // Determine collection from article tags
    var bodyClasses = document.body.className || '';
    var pageUrl = window.location.pathname || '';
    var ctaUrl = '/collections/all';
    var ctaText = 'Shop All Rugs';
    var ctaIcon = '🛍';
    var ctaDesc = 'Hand-knotted area rugs — free shipping, free 30-day returns.';

    // Try to detect from page URL or body data
    var tagMeta = document.querySelector('meta[name="article:tag"]');
    var tags = tagMeta ? tagMeta.content.toLowerCase() : (pageUrl + ' ' + bodyClasses).toLowerCase();

    if (tags.includes('wool')) {
      ctaUrl = '/collections/wool-rugs'; ctaText = 'Shop Wool Rugs'; ctaIcon = '🏺';
      ctaDesc = 'Hand-knotted wool rugs from $189 — free shipping, free 30-day returns.';
    } else if (tags.includes('washable') || tags.includes('machine-washable') || tags.includes('machine washable')) {
      ctaUrl = '/collections/washable-rugs'; ctaText = 'Shop Washable Rugs'; ctaIcon = '🧺';
      ctaDesc = 'Machine washable rugs — stain-resistant, pet-friendly, from $99.';
    } else if (tags.includes('outdoor')) {
      ctaUrl = '/collections/outdoor-rugs'; ctaText = 'Shop Outdoor Rugs'; ctaIcon = '🌿';
      ctaDesc = 'Weather-resistant outdoor rugs — UV-fade proof, easy to clean.';
    } else if (tags.includes('persian') || tags.includes('oriental')) {
      ctaUrl = '/collections/persian-rugs'; ctaText = 'Shop Persian Rugs'; ctaIcon = '🏺';
      ctaDesc = 'Hand-knotted Persian rugs — authentic designs, heirloom quality.';
    } else if (tags.includes('shag')) {
      ctaUrl = '/collections/shag-rugs'; ctaText = 'Shop Shag Rugs'; ctaIcon = '🛋';
      ctaDesc = 'Plush shag rugs — ultra-soft, available in all sizes.';
    } else if (tags.includes('living room')) {
      ctaUrl = '/collections/living-room-rugs'; ctaText = 'Shop Living Room Rugs'; ctaIcon = '🛋';
      ctaDesc = 'Living room rugs in every size and style — free shipping.';
    } else if (tags.includes('bedroom')) {
      ctaUrl = '/collections/bedroom-rugs'; ctaText = 'Shop Bedroom Rugs'; ctaIcon = '🛏';
      ctaDesc = 'Soft, cozy bedroom rugs — find the perfect size for your space.';
    }

    function makeCTA(icon, text, desc, url) {
      var div = document.createElement('div');
      div.className = 'rk-mid-cta';
      div.innerHTML =
        '<div class="rk-mid-cta__icon">' + icon + '</div>' +
        '<div class="rk-mid-cta__body">' +
          '<strong>' + text + '</strong>' +
          '<p>' + desc + '</p>' +
          '<a href="' + url + '">' + text + ' →</a>' +
        '</div>';
      return div;
    }

    var third = Math.floor(headings.length / 3);
    var twoThird = Math.floor(headings.length * 2 / 3);

    if (headings[third]) {
      headings[third].before(makeCTA(ctaIcon, ctaText, ctaDesc, ctaUrl));
    }
    if (headings[twoThird] && twoThird !== third) {
      // Second CTA: pet/washable variant if first was wool, else complement
      var cta2Url = '/collections/washable-rugs', cta2Text = 'Shop Washable Rugs', cta2Icon = '🐾';
      var cta2Desc = 'Pet-friendly, machine washable rugs — stain-resistant from $99.';
      if (ctaUrl.includes('washable')) {
        cta2Url = '/collections/wool-rugs'; cta2Text = 'Shop Wool Rugs'; cta2Icon = '🏺';
        cta2Desc = 'Natural wool rugs — durable, soft, and beautiful for any room.';
      }
      headings[twoThird].before(makeCTA(cta2Icon, cta2Text, cta2Desc, cta2Url));
    }
  }

  /* ---- Init ---- */
  function init() {
    initProgressBar();
    initReadTime();
    initMidCTAs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
